
import { defineComponent } from "vue";
import InquiriesBar from "@/components/communities/organisms/InquiriesBar.vue";

export default defineComponent({
  props: {
  },
  components: { InquiriesBar },
});
